import { render, staticRenderFns } from "./asan-pardakht.vue?vue&type=template&id=6d22b37f"
import script from "./asan-pardakht.vue?vue&type=script&lang=js"
export * from "./asan-pardakht.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports